var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBracketsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentFill",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M18.5 1H2V23H22V4.5L18.5 1Z",
    stroke: "#F1F0ED",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 7.00429H9.33333C9.00444 6.97102 8.68001 7.1323 8.4304 7.45317C8.1808 7.77404 8.02615 8.22861 8 8.71828V10.37C7.99463 10.6647 7.93682 10.9519 7.83249 11.2023C7.72816 11.4528 7.58105 11.6574 7.40622 11.7953L6 13.0006L7.40622 14.2046C7.58093 14.3427 7.72794 14.5474 7.83225 14.7978C7.93656 15.0482 7.99445 15.3353 8 15.6299V17.2829C8.02614 17.7725 8.18082 18.227 8.43046 18.5476C8.68009 18.8683 9.00453 19.0293 9.33333 18.9956H10",
    stroke: "useStroke",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 7.00438H14.6667C14.9956 6.97075 15.3202 7.13191 15.5698 7.45285C15.8195 7.77378 15.9741 8.22855 16 8.71836V10.3701C16.0054 10.6647 16.0632 10.952 16.1675 11.2024C16.2718 11.4528 16.4189 11.6574 16.5938 11.7953L18 13.0007L16.5938 14.2047C16.4191 14.3428 16.2721 14.5475 16.1677 14.7978C16.0634 15.0482 16.0056 15.3353 16 15.6299V17.283C15.9739 17.7725 15.8192 18.227 15.5695 18.5476C15.3199 18.8683 14.9955 19.0293 14.6667 18.9956H14",
    stroke: "useStroke",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketsIcon);
export default __webpack_public_path__ + "static/media/brackets_icon.320e19ff99162bbf8ed1f5bf4ac0d370.svg";
export { ForwardRef as ReactComponent };